import React from 'react';
import { Button, Frame, SageTokens } from '@kajabi/sage-react';
import { useUiResourceContext, useResultContext } from '../../contexts';

const FeedbackSentiment = () => {
  const { feedbackSentiment, setFeedbackSentiment, loading } = useUiResourceContext();
  const { result } = useResultContext();

  const handleClick = (positive: boolean) => {
    setFeedbackSentiment({ positive });
  };

  const disabled = loading || !result;

  const thumbUpIcon = feedbackSentiment?.positive
    ? SageTokens.ICONS.THUMB_UP_FILLED
    : SageTokens.ICONS.THUMB_UP;

  const thumbDownIcon =
    feedbackSentiment?.positive === false
      ? SageTokens.ICONS.THUMB_DOWN_FILLED
      : SageTokens.ICONS.THUMB_DOWN;

  return (
    <Frame
      align={Frame.ALIGNMENTS.CENTER_SPREAD}
      direction={Frame.DIRECTIONS.HORIZONTAL}
      gap={Frame.GAPS.SM}
      width={Frame.WIDTHS.HUG}
    >
      <div>How did we do?</div>
      <Button
        data-testid="thumbs-up"
        disabled={disabled}
        icon={thumbUpIcon}
        iconOnly
        onClick={() => handleClick(true)}
        selected
        small
        subtle
      />
      <Button
        data-testid="thumbs-down"
        disabled={disabled}
        icon={thumbDownIcon}
        iconOnly
        onClick={() => handleClick(false)}
        selected
        small
        subtle
      />
    </Frame>
  );
};

export default FeedbackSentiment;
